import { ref, computed } from 'vue';
import { useComponentI18n } from '@rdrive/i18n';
import messages from './messages/index.js';

export default (props, { emit }) => {
    // LOCAL composer with the warn flags off — see @rdrive/i18n for why the flags are
    // assigned rather than passed. (It read the app's GLOBAL composer before the move.)
    const { t } = useComponentI18n(messages);

    const updateDialog = (value) => {
        emit('update:modelValue', value);
    };

    const closeDialog = () => {
        emit('update:modelValue', false);
    };

    const selectedMode = ref('grid')
    const selectedReportType = ref('By Category Subcategory')
    const selectedFileFormat = ref('PDF')
    const selectedPageSize = ref('A4')
    // The opt-in Grid-mode selects (issue-analysis, IA_ABSORPTION_PLAN 13.4): initially the first option
    const selectedGroupBy = ref(props.groupByOptions[0]?.value)
    const selectedOrderBy = ref(props.orderByOptions[0]?.value)

    const reportTypes = [
        { title: t('byCategory'), value: 'By Category Subcategory', icon: 'mdi-shape-outline' },
        { title: t('byDrawingLocation'), value: 'By Drawing Location', icon: 'mdi-map-marker-outline' },
        { title: t('byDrawingAssignee'), value: 'By Drawing Assignee', icon: 'mdi-account-outline' },
        { title: t('byController'), value: 'By Controller', icon: 'mdi-gauge' }
    ]

    const fileFormats = [
        { title: 'PDF', value: 'PDF', icon: 'mdi-file-pdf-box' },
        { title: 'Word', value: 'WORDOPENXML', icon: 'mdi-microsoft-word' },
        { title: 'Excel', value: 'EXCELOPENXML', icon: 'mdi-microsoft-excel' },
        { title: 'CSV', value: 'CSV', icon: 'mdi-file-delimited' },
        { title: 'HTML5', value: 'HTML5', icon: 'mdi-language-html5' },
        { title: 'IMAGE (tiff)', value: 'IMAGE', icon: 'mdi-file-image' },
        { title: 'XML', value: 'XML', icon: 'mdi-file-code' }
    ]

    const pageSizes = [
        { title: 'A4', value: 'A4' },
        { title: 'A3', value: 'A3' }
    ]

    const showPageSizeOption = computed(() => {
        const spreadsheetFormats = ['EXCEL', 'EXCELOPENXML', 'CSV', 'XML']
        return !spreadsheetFormats.includes(selectedFileFormat.value)
    })

    const isFormValid = computed(() => {
        if (!selectedFileFormat.value) return false
        if (selectedMode.value === 'matrix' && !selectedReportType.value) return false
        if (showPageSizeOption.value && !selectedPageSize.value) return false
        return true
    })

    // pageSize is '' for the spreadsheet formats, which the parent turns into
    // the " - Excel" report-name suffix. groupBy/orderBy only when the parent gave
    // their options, so project-overview's payload keeps its four keys.
    const requestReport = () => {
        const options = {
            mode: selectedMode.value,
            reportType: selectedReportType.value,
            fileFormat: selectedFileFormat.value,
            pageSize: showPageSizeOption.value ? selectedPageSize.value : ''
        };
        if (props.groupByOptions.length) options.groupBy = selectedGroupBy.value;
        if (props.orderByOptions.length) options.orderBy = selectedOrderBy.value;
        emit('generate', options);
    };

    return {
        t,
        updateDialog,
        closeDialog,
        selectedMode,
        selectedReportType,
        selectedFileFormat,
        selectedPageSize,
        selectedGroupBy,
        selectedOrderBy,
        reportTypes,
        fileFormats,
        pageSizes,
        showPageSizeOption,
        isFormValid,
        requestReport
    };
};
